import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { Button } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import { Check } from '@material-ui/icons';


// Exchanges Icon

import Binance from "./Icons/Binance.png"
import Liquid from './Icons/Liquid.png'
import Bitinka from './Icons/Bitinka.png'
import Bilaxy from './Icons/Bilaxy.png'
import Gemini from './Icons/Gemini.png'
import Bittrex from './Icons/Bittrex.png'
import DragonEx from './Icons/DragonEx.png'
import Bitfinex from './Icons/Bitfinex.png'
import Bitstamp from './Icons/Bitstamp (light).png'
import CoinEgg from './Icons/CoinEgg.png'
import BTCTurk from './Icons/BTCTurk.png'
import Escodex from './Icons/Escodex.png'
import Gate from './Icons/Gate.io.png'
import HitBTC from './Icons/HitBTC.png'
import Huobi from './Icons/Huobi.png'
import Kraken from './Icons/Kraken.png'
import YoBit from './Icons/YoBit.png'






function createData(Exchange, OrderTypes, Smarttrade, DCABot, GridBot,OptionsBot,Volume,TradingPairs,Connect) {
  return { Exchange, OrderTypes, Smarttrade, DCABot, GridBot,OptionsBot,Volume,TradingPairs,Connect };
}
                                    // Table's Data
const rows = [
                                //  Binance 
  createData(
    <GridContainer>
      <img width="40" height="40"  src={Binance} alt="fireSpot"/>
      <p>Binance</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px", marginLeft:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p>
      

        
        <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p>
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>,

    "",

    "$ 49.56 B",

    "972",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                      // FTX
  createData(
    <GridContainer>
      <img width="40" height="40" src={Liquid} alt="fireSpot"/>
      <p>FTX</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"1px", background:"#d6fffb"}} >Spot</p>
      

        
        <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p>
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>,

    "",

    "	$ 9.5 B",

    "412",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                                  // Bitinka
  createData(
    <GridContainer>
      <img width="40" height="40" src={Bitinka} alt="fireSpot"/>
      <p>Bitinka</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        {/* <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p> */}
      

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p>
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>,

    "",

    "$ 8.56 B	",

    "4",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                // BitMEX
  createData(
    <GridContainer>
      <img width="40" height="40" src={Bilaxy} alt="fireSpot"/>
      <p>BitMEX</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        {/* <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p> */}
      

        
        <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p>
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>,

    "",

    "$ 2.15 B	",

    "972",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                  // Deribit
  createData(
    <GridContainer>
      <img width="40" height="40" src={Gemini} alt="fireSpot"/>
      <p>Deribit</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Options</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    "", 

    "", 

    "",

    <Check style={{color:"green"}}/>,

    "$ 864.49 M	",

    "606",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                        // Bittrex
  createData(
    <GridContainer>
      <img width="40" height="40" src={Bittrex} alt="fireSpot"/>
      <p>Bittrex</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>, 

    "",

    "",

    "$ 187.78 M	",

    "708",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                          // Binance DEX
  createData(
    <GridContainer>
      <img width="40" height="40" src={DragonEx} alt="fireSpot"/>
      <p>Binance DEX</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 992 Thousand	",

    "223",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                                // Binance US
  createData(
    <GridContainer>
     <img width="40" height="40" src={Binance} alt="fireSpot"/>
      <p>Binance US</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>,

    "",

    "	$ 360.25 M",

    "104",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                        // Bitfinex
  createData(
    <GridContainer>
      <img width="40" height="40" src={Bitfinex} alt="fireSpot"/>
      <p>Bitfinex</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 948.85 M	",

    "300",

    <a href="#"><Button style={{background:"#00acc1",}}>Sign Up</Button></a>
  ),
                                                          // Bitstamp	
  createData(
    <GridContainer>
      <img width="40" height="40" src={Bitstamp} alt="fireSpot"/>
      <p>Bitstamp	</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

     <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 440.81 M	",

    "54",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                              // CEX.IO
  createData(
    <GridContainer>
      <img width="40" height="40" src={CoinEgg} alt="fireSpot"/>
      <p>CEX.IO</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 14.26 M	",

    "187",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                        // Coinbase Pro (GDAX)
  createData(
    <GridContainer>
      <img width="40" height="40" src={BTCTurk} alt="fireSpot"/>
      <p>Coinbase Pro (GDAX)</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>,

    "",

    "No data	",

    "125",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                          // EXMO
  createData(
    <GridContainer>
      <img width="40" height="40" src={Escodex} alt="fireSpot"/>
      <p>EXMO</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 51.78 M	",

    "184",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                            // Gate.io	
  createData(
    <GridContainer>
      <img width="40" height="40" src={Gate} alt="fireSpot"/>
      <p>Gate.io	</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 51.78 M	",

    "184",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                            // HitBTC
  createData(
    <GridContainer>
      <img width="40" height="40" src={HitBTC} alt="fireSpot"/>
      <p>HitBTC</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px", marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 2.42 B	",

    "1082",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                  // Huobi
  createData(
    <GridContainer>
      <img width="40" height="40" src={Huobi} alt="fireSpot"/>
      <p>Huobi</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p>
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    <Check style={{color:"green"}}/>, 

    "",

    "",

    "$ 21.6 B	",

    "915",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                              // Kraken
  createData(
    <GridContainer>
      <img width="40" height="40" src={Kraken} alt="fireSpot"/>
      <p>Kraken</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 1.33 B	",

    "291",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
                                                    // YoBit
  createData(
    <GridContainer>
     <img width="40" height="40" src={YoBit} alt="fireSpot"/>
      <p>YoBit</p>

    </GridContainer>,

    <GridContainer style={{width:"174px", direction:"rtl"}} >

        
        <p style={{borderRadius:"5px",marginRight:"5px", background:"#d6fffb"}} >Spot</p>
      

        
        {/* <p style={{borderRadius:"5px", marginLeft:"5px",marginRight:"5px", background:"#d6fffb"}} >Futures</p> */}
      

        
        {/* <p style={{borderRadius:"5px",  marginLeft:"5px", background:"#d6fffb"}} >Margin</p> */}
      

    </GridContainer>, 

    <Check style={{color:"green"}}/>, 

    "", 

    "",

    "",

    "$ 7.5 M	",

    "32",

    <a href="#"><Button style={{background:"#00acc1"}}>Sign Up</Button></a>
  ),
  
//   createData('Donut', 452, 25.0, 51, 4.9),
//   createData('Eclair', 262, 16.0, 24, 6.0),
//   createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
//   createData('Gingerbread', 356, 16.0, 49, 3.9),
//   createData('Honeycomb', 408, 3.2, 87, 6.5),
//   createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
//   createData('Jelly Bean', 375, 0.0, 94, 0.0),
//   createData('KitKat', 518, 26.0, 65, 7.0),
//   createData('Lollipop', 392, 0.2, 98, 0.0),
//   createData('Marshmallow', 318, 0, 81, 2.0),
//   createData('Nougat', 360, 19.0, 9, 37.0),
//   createData('Oreo', 437, 18.0, 63, 4.0),
    
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'Exchange', numeric: false, disablePadding: true, label: 'Exchange' },
  { id: 'OrderTypes', numeric: true, disablePadding: false, label: 'OrderTypes' },
  { id: 'Smarttrade', numeric: true, disablePadding: false, label: 'Smarttrade' },
  { id: 'DCABot', numeric: true, disablePadding: false, label: 'DCABot' },
  { id: 'GridBot', numeric: true, disablePadding: false, label: 'GridBot' },
  { id: 'OptionsBot', numeric: true, disablePadding: false, label: 'OptionsBot' },
  { id: 'Volume', numeric: true, disablePadding: false, label: 'Volume' },
  { id: 'TradingPairs', numeric: true, disablePadding: false, label: 'TradingPairs' },
  { id: 'Connect', numeric: true, disablePadding: false, label: 'Connect' },
];

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          {/* <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          /> */}
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton aria-label="filter list">
            {/* <FilterListIcon /> */}
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable() {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                    //   onClick={(event) => handleClick(event, row.name)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        {/* <Checkbox
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        /> */}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row" padding="none">
                        {row.Exchange}
                      </TableCell>
                      <TableCell align="right">{row.OrderTypes}</TableCell>
                      <TableCell align="right">{row.Smarttrade}</TableCell>
                      <TableCell align="right">{row.DCABot}</TableCell>
                      <TableCell align="right">{row.GridBot}</TableCell>
                      <TableCell align="right">{row.OptionsBot}</TableCell>
                      <TableCell align="right">{row.Volume}</TableCell>
                      <TableCell align="right">{row.TradingPairs}</TableCell>
                      <TableCell align="right">{row.Connect}</TableCell>
                    </TableRow>
                    
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
      
    </div>
  );
}
